import React from 'react';
import {Divider} from "@material-ui/core";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";

const LineScreenComponent = (props) => {
    const styles = props.element.styles[0];
    return (
        <div
            style={{
                padding: styles.padding,
                margin: styles.margin,
                width: styles.width,
                border: '1px solid transparent'
            }}
        >
            <Divider variant={styles.fullWidth || 'fullWidth'}
                     style={{background: styles.color}}/>
        </div>
    );
};

export default JsonScreenHoc(LineScreenComponent);